/* ONE BOUT — scroll reveal (SV44, Svitlana 30. 9.; ref. kindredofireland.com)
   Every content section below the fold fades in and glides up ~32px the first time it enters the viewport.
   - Armed only with JS + IntersectionObserver + no prefers-reduced-motion, never in the theme editor
     (html.ob-reveal-on is added here, so nothing is ever hidden without this script).
   - Sections already on screen at load are left alone (no flash on first paint).
   - Skipped: the first section (hero), sections with drawers / sticky UI or their own motion (product, collection,
     search, cart, password, OB values with its own fade), and anything marked data-ob-no-reveal.
   - After the transition the element drops the attribute, so no transform stays behind (fixed / sticky children
     inside revealed sections behave exactly as before).
   Styles: assets/ob-base.css §0c. */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SKIP = [
    'shopify-section--main-product',
    'shopify-section--main-collection',
    'shopify-section--main-search',
    'shopify-section--main-cart',
    'shopify-section--main-password',
    'shopify-section--ob-hero'
  ];

  const init = () => {
    const main = document.querySelector('main') || document.getElementById('main');
    if (!main) return;
    const sections = Array.from(main.querySelectorAll(':scope > .shopify-section, :scope > * > .shopify-section'));
    const targets = [];
    sections.forEach((section, index) => {
      if (index === 0) return;                                        // the hero / page head
      if (SKIP.some((cls) => section.classList.contains(cls))) return;
      if (section.querySelector('[data-ob-no-reveal], .ob-values.is-armed, dialog, x-drawer, facets-drawer')) return;
      // the section's first rendered box (sections start with their <link rel=stylesheet> / <script> tags)
      const el = Array.from(section.children).find((child) => !/^(LINK|SCRIPT|STYLE|TEMPLATE|NOSCRIPT)$/.test(child.tagName) && child.offsetHeight > 0);
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) return;               // already visible at load → no animation
      targets.push(el);
    });
    if (!targets.length) return;

    document.documentElement.classList.add('ob-reveal-on');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        io.unobserve(el);
        el.classList.add('is-revealed');
        const done = () => { el.removeAttribute('data-ob-reveal'); el.classList.remove('is-revealed'); };
        el.addEventListener('transitionend', (event) => { if (event.target === el && event.propertyName === 'transform') done(); });
        setTimeout(done, 1600);                                        // safety net (transition interrupted)
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });

    targets.forEach((el) => { el.setAttribute('data-ob-reveal', ''); io.observe(el); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
